<script lang="ts">
	interface Props {
		percentage: any
		showPercentage?: boolean
		width?: string
	}

	let { percentage = $bindable(), showPercentage = false, width = undefined }: Props = $props()
	let renderablePercent = $derived(Math.min(percentage, 1))
</script>

<div class="progress-bar" style="width: {width}">
	<div
		class="progress-bar-indicator"
		style="transform: translateX({renderablePercent * 100 - 100}%)"
	>
		{#if showPercentage}
			<span class="percent-display">{Math.round(percentage * 100)}%</span>
		{/if}
	</div>
</div>

<style>
	.progress-bar {
		border-radius: var(--br);
		min-width: 10rem;
		height: 1rem;
		/* border: 1px solid var(--color-text); */
		margin: 0;
		overflow: hidden;
		background-color: var(--color-bg-dark);
	}

	.progress-bar-indicator {
		position: relative;
		border-radius: var(--br);
		background-color: var(--color-main);
		width: 100%;
		height: 100%;
		transform: translateX(-100%);
		transition: transform var(--transition-duration);

		display: flex;
		flex-direction: row;
		justify-content: flex-end;
	}

	.percent-display {
		color: var(--color-text-dark);
		font-size: 1rem;
		line-height: 0.75em;
		padding-right: 0.25rem;
	}
</style>
